import DeviceContext from './device.context';
import SocketContext, { socket } from './socket.context';

export default {
	socket,
	DeviceContext,
	SocketContext
};
